import { TbMessageX } from 'react-icons/tb'

import { dictionaryCodeFormTemplate } from '../Components/DictionaryCodeHint'
import { TopMenu } from '../Components/TopMenu'
import { DICTIONARY_SEARCH_FIELDS } from '../Contracts/DictionaryFields'
import { LOSS_REASON_LIST_COLUMNS, LOSS_REASON_LIST_FILTERS, lossReasonListFields } from '../Contracts/LossReasonListFields'
import { CheckDictionaryPageAccessTask } from '../Tasks/CheckDictionaryPageAccessTask'

import type { IResourceConfig } from '@/Core/Contracts/UI'

/**
 * Довідник «Причини програшу запитів» (сім'я `LossReasonList`, `SPEC-007` §4).
 *
 * Чому запит програно (етап 2).
 *
 * Сторінку бачить лише той, кому бек дає створення довідників, тобто
 * адміністратор (`pageConfig.accessFn`, `SPEC-007` §7.1); читати довідник для
 * селектів може кожен.
 */
export const ListRequestLossReasonResource: IResourceConfig = {
    title: 'Причини програшу запитів',
    fields: lossReasonListFields(),
    table: {
        showColumns: LOSS_REASON_LIST_COLUMNS,
    },
    filter: {
        includeFields: LOSS_REASON_LIST_FILTERS,
    },
    // Підказка про код — у формі, над полем «Код» (`SPEC-007` §12)
    form: {
        template: dictionaryCodeFormTemplate,
    },
    places: {
        top: <TopMenu current="request-loss-reasons" />,
    },
    restUrl: '/services/request_loss_reasons',
    pageUrl: '/settings/request-loss-reasons',
    pageConfig: {
        title: 'Причини програшу запитів',
        icon: <TbMessageX />,
        accessFn: CheckDictionaryPageAccessTask,
    },
    settings: {
        searchFields: DICTIONARY_SEARCH_FIELDS,
    },
}
